// extracted by mini-css-extract-plugin
module.exports = {"header":"ReferencesInfoResult_header__F6plz","button":"ReferencesInfoResult_button__TWY0U"};